// USER
export const GOT_USER = 'GOT_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const ADD_USER_ROOMS = 'UPDATE_USER_ROOMS';
export const ADD_USER_COURSES = 'ADD_USER_COURSES';
export const ADD_USER_ACTIVITIES = 'ADD_USER_ACTIVITIES';
export const UPDATE_USER_COURSE_ACCESS_NTFS = 'UPDATE_USER_COURSE_ACCESS_NTFS';
export const ADD_USER_COURSE_TEMPLATES = 'ADD_USER_COURSE_TEMPLATES';
export const REMOVE_USER_COURSE = 'REMOVE_USER_COURSE';
export const REMOVE_USER_ACTIVITIES = 'REMOVE_USER_ACTIVITIES';
export const REMOVE_USER_ROOMS = 'REMOVE_USER_ROOMS';
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const LOGOUT = 'LOGOUT';
export const TOGGLE_JUST_LOGGED_IN = 'TOGGLE_JUST_LOGGED_IN';
export const ADD_ROOM_TO_ARCHIVE = 'ADD_ROOM_TO_ARCHIVE';
export const UNARCHIVE_USER_ROOM = 'UNARCHIVE_USER_ROOM';
export const SAVE_COMPONENT_UI_STATE = 'SAVE_COMPONENT_UI_STATE';
export const STORE_PRESUMPTIVE_GMAIL = 'STORE_PRESUMPTIVE_GMAIL';

// LOADING
export const START = 'START';
export const SUCCESS = 'SUCCESS';
export const FAIL = 'FAIL';
export const ACCESS_SUCCESS = 'ACCESS_SUCCESS';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const CLEAR_ALL = 'CLEAR_ALL';
export const UPDATE_FAIL = 'UPDATE_FAIL';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const CONFIRM_EMAIL_SUCCESS = 'CONFIRM_EMAIL_SUCCESS';
export const CONFIRM_EMAIL_START = 'CONFIRM_EMAIL_START';
export const CONFIRM_EMAIL_FAIL = 'CONFIRM_EMAIL_FAIL';

// COURSES
export const GOT_COURSES = 'GOT_COURSES';
export const CREATED_COURSE = 'CREATED_COURSE';
export const GOT_CURRENT_COURSE = 'GOT_CURRENT_COURSE';
export const UPDATED_COURSE = 'UPDATED_COURSE';
export const ADD_COURSE_ROOMS = 'ADD_COURSE_ROOMS';
export const ADD_COURSE_ACTIVITIES = 'ADD_COURSE_ACTIVITIES';
export const GRANT_ACCESS = 'GRANT_ACCESS';
export const CLEAR_COURSE = 'CLEAR_COURSE';
export const REMOVE_COURSE = 'REMOVE_COURSE';
export const REMOVE_COURSE_ACTIVITIES = 'REMOVE_COURSE_ACTIVITIES';
export const REMOVE_COURSE_ROOM = 'REMOVE_COURSE_ROOM';
export const ADD_COURSE_MEMBER = 'ADD_COURSE_MEMBER';
export const ADD_ROOM_TO_COURSE_ARCHIVE = 'ADD_ROOM_TO_COURSE_ARCHIVE';
export const REMOVE_ROOM_FROM_COURSE_ARCHIVE =
  'REMOVE_ROOM_FROM_COURSE_ARCHIVE';

// ACTIVITIES
export const GET_ACTIVITIES = 'GET_ACTIVITIES';
export const GOT_ACTIVITIES = 'GOT_ACTIVITIES';
export const ADD_ACTIVITY = 'ADD_ACTIVITY';
export const ADD_ACTIVITY_ROOMS = 'ADD_ACTIVITY_ROOMS';
export const ADD_ACTIVITY_USER = 'ADD_ACTIVITY_USER';
export const REMOVE_ACTIVITY_USER = 'REMOVE_ACTIVITY_USER';
export const CREATED_ACTIVITY = 'CREATED_ACTIVITY';
export const CREATE_ACTIVITY_CONFIRMED = 'CREATE_ACTIVITY_CONFIRMED';
export const CLEAR_ACTIVITY = 'CLEAR_ACTIVITIES';
export const REMOVE_ACTIVITIES = 'REMOVE_ACTIVITIES';
export const UPDATED_ACTIVITY = 'UPDATED_ACTIVITY';
export const UPDATED_ACTIVITY_TAB = 'UPDATED_ACTIVITY_TAB';
export const REMOVE_ACTIVITY_ROOM = 'REMOVE_ACTIVITY_ROOM';

// ROOMS
export const GET_ROOMS = 'GET_ROOMS';
export const GOT_ROOMS = 'GOT_ROOMS';
export const UPDATED_ROOM = 'UPDATED_ROOM';
export const CREATED_ROOM = 'CREATED_ROOM';
export const CREATE_ROOM_CONFIRMED = 'CREATE_ROOM_CONFIRMED';
export const CLEAR_ROOM = 'CLEAR_ROOM';
export const REMOVE_ROOM = 'REMOVE_ROOM';
export const ADD_ROOM_MEMBER = 'ADD_ROOM_MEMBER';
export const REMOVE_ROOM_MEMBER = 'REMOVE_ROOM_MEMBER';
export const UPDATED_ROOM_TAB = 'UPDATED_ROOM_TAB';
export const ADD_TO_LOG = 'ADD_TO_LOG';
export const REMOVE_ROOMS = 'REMOVE_ROOMS';

// COURSE TEMPLATES
export const GOT_COURSE_TEMPLATES = 'GOT_COURSE_TEMPLATES';
export const GET_COURSE_TEMPLATES = 'GET_COURSE_TEMPLATES';
export const UPDATE_COURSE_ACTIVITIES = 'UPDATE_COURSE_ACTIVITIES';
export const CREATE_COURSE_TEMPLATE = 'CREATE_COURSE_TEMPLATE';
export const CREATED_COURSE_TEMPLATE = 'CREATED_COURSE_TEMPLATE';

// TRASH
export const REMOVE_RESOURCE = 'REMOVE_RESOURCE';
export const MOVE_CARD = 'MOVE_CARD';



// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.js